import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import { Button } from "@material-ui/core";
import SearchForms from "../Forms/SearchForms";
import { _get } from "../../Api";
import { toast } from "react-toastify";

export default function SetupUbereatsStore(props) {
  const [doSetup, setDoSetup] = useState(false);
  return (
    <Box>
      <Button
        variant={"outlined"}
        onClick={() => {
          setDoSetup(true);
        }}
      >
        Setup
      </Button>

      {doSetup && <Setup handleSelect={props.handleSelect} />}
    </Box>
  );
}

function Setup(props) {
  return (
    <SearchForms
      noResultsText={"Loading"}
      variant={"outlined"}
      label={"stores"}
      getValue={(o) => o.name}
      handleSelect={(option) => {
        props.handleSelect(option)
      }}
      getResults={() => {
        return new Promise((resolve) => {
          listStores().then((res) => {
            console.log(res);
            resolve(res.stores);
          });
        });
      }}
    />
  );
}

function listStores() {
  return _get(`/nova/v2/ubereats_merchants/list_stores`)
    .catch((err) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      return Promise.reject();
    })
    .then((res) => {
      return Promise.resolve(res.data);
    });
}
